import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getTickets = async (tipo, estado,numTicket, codigoEquipo) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/tickets?empresa=${userInfo.empresa}&tipo=${tipo}&estado=${estado}&numTicket=${numTicket}&codigoEquipo=${codigoEquipo}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

export const getTicketsUserInbox = async (tipo,estado,numTicket, codigoEquipo) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/tickets/userinbox?empresa=${userInfo.empresa}&tipo=${tipo}&idAsignado=${userInfo.usuario}&estado=${estado}&numTicket=${numTicket}&codigoEquipo=${codigoEquipo}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearTicket = async (clienteData) => {
    try {
      const userInfo = fetchUser();
      clienteData.empresa = userInfo.empresa;

        const {data}  = await Axios.post(
            '/tickets', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateTicketAsigndo = async (newData) => {
    try {

        const {data}  = await Axios.post(
            '/tickets/asignado', newData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateTicket = async (clienteData) => {
    try {
      const userInfo = fetchUser();
      clienteData.empresa = userInfo.empresa;
      
        const {data}  = await Axios.patch(
          `/tickets/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const updateEstadoTicket = async (clienteData) => {
    try {

      
        const {data}  = await Axios.patch(
          `/tickets/estado/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteTicket = (Id) => Axios.delete(`/tickets/${Id}`);
